import axios from "axios";
import {urlConfig} from "../config";

export default class RMMService {

    static getRMMProfile(cid) {

        const ottServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}/video/getRMMProfile?cid=${cid}`});
        // const ottServiceInstance = axios.create({baseURL: `http://localhost:1339/video/getRMMProfile?cid=${cid}`});

        return ottServiceInstance.get();
    }

}